import { Color } from './color';
/**
 * 工
 */
export const Tick = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'tick' }, options), context);
};
Tick.props = Object.assign({ defaultMarker: 'tick' }, Color.props);
//# sourceMappingURL=tick.js.map